<template>
  <div>
    <v-btn text block @click.stop="startVerdict" class="report-button" v-if="$vuetify.breakpoint.mdAndUp">
      <v-icon class="mr-3">
        fas fa-gavel
      </v-icon>
      <span class="color-new-link-blue--text">{{ $t('v-text-1') }}</span>
    </v-btn>
    <span @click.stop="startVerdict" v-else>
      {{ $t('v-text-1') }}
    </span>
    <v-dialog v-model="verdictDialog"
              :fullscreen="dialogSettings.fullscreen"
              :scrollable="dialogSettings.scrollable"
              :hide-overlay="dialogSettings.hideoverlay"
              :transition="dialogSettings.transition"
              :width="dialogSettings.width"
              :max-width="dialogSettings.maxwidth">
      <verdict-dialog :debts="verdictDebt" @close="verdictDialog = false"></verdict-dialog>
    </v-dialog> 
  </div>
</template>

<script>
  import VerdictDialog from './VerdictDialog.vue';

  export default {
    props: ['debtNr'],
    data: function () {
      return {
        verdictDialog: false,
        verdictDebt: null
      }
    },
    methods: {
      startVerdict () {
        let debts = []
        debts[0] = this.$store.getters.getSingleDebt(this.debtNr)
        this.verdictDebt = debts
        this.verdictDialog = true
        this.$matomo && this.$matomo.trackEvent("Action", "Download Court's Decision", "Decision Start")
      }
    },
    computed: {
      dialogSettings () {
        return {
          fullscreen: this.$vuetify.breakpoint.smAndDown,
          scrollable: false,
          hideoverlay: this.$vuetify.breakpoint.smAndDown,
          transition: this.$vuetify.breakpoint.smAndDown ? 'dialog-bottom-transition' : 'dialog-transition',
          width: this.$vuetify.breakpoint.smAndDown ? 'auto' : '1024px',
          maxwidth: this.$vuetify.breakpoint.smAndDown ? 'none' : '90%'
        }
      }
    },
    components: {
      'verdict-dialog': VerdictDialog
    }
  }
</script>

<i18n>
  {
  "fi": {
  "v-text-1": "Lataa käräjäoikeuden ratkaisu"
  },
  "se": {
  "v-text-1": "Ladda ner tingsrättens beslut "
  },
  "en": {
  "v-text-1": "Download court's decision"
  }
  }
</i18n>
